var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDigitalTwin = function SvgDigitalTwin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8a2 2 0 0 0-2 2M20 8a2 2 0 0 1 2 2M22 20a2 2 0 0 1-2 2M10 22a2 2 0 0 1-2-2M14 8h2M14 22h2M8 14v2M22 14v2"
  })));
};
export default SvgDigitalTwin;